import { PLANNING_MEETING_FORM_VERSION } from '../constants/general';

export const isValidPhoneNumber = (phone) => {
  if (!phone) return false;
  const digits = phone.replace(/\D/g, '');
  return digits.length === 10;
};

export const validatePlanSection = (form, planSuffix, planType, requiredFields, rc) => {
  // 4-Year College or 2-Year College
  if (planType === 'college' || planType === '2-year-college') {
    if (!form['nameLocation' + planSuffix] || form['nameLocation' + planSuffix].length === 0) {
      requiredFields.push({ requirement: `Please indicate the name of the College Name/Location for Plan ${planSuffix}.` });
      rc.value = false;
    }
    if (!form['fall4YearMajor' + planSuffix] || form['fall4YearMajor' + planSuffix].length === 0) {
      requiredFields.push({ requirement: `Please indicate your Plan ${planSuffix} Major.` });
      rc.value = false;
    }
    if (!form['fall4YearCareerGoal' + planSuffix] || form['fall4YearCareerGoal' + planSuffix].length === 0) {
      requiredFields.push({ requirement: `Please indicate your Plan ${planSuffix} Career Goals.` });
      rc.value = false;
    }
    if (!form['fall4YearStartDate' + planSuffix] || form['fall4YearStartDate' + planSuffix].length === 0) {
      requiredFields.push({ requirement: `Please indicate your Plan ${planSuffix} Start Date.` });
      rc.value = false;
    }

    if (!form['fall4YearCostTuition' + planSuffix] || form['fall4YearCostTuition' + planSuffix].length === 0) {
      requiredFields.push({ requirement: `Please indicate your Tuition costs for Plan ${planSuffix}.` });
      rc.value = false;
    }
    if (!form['fall4YearCostBooks' + planSuffix] || form['fall4YearCostBooks' + planSuffix].length === 0) {
      requiredFields.push({ requirement: `Please indicate your Books costs for Plan ${planSuffix}.` });
      rc.value = false;
    }
    if (!form['fall4YearCostHousing' + planSuffix] || form['fall4YearCostHousing' + planSuffix].length === 0) {
      requiredFields.push({ requirement: `Please indicate your Housing costs for Plan ${planSuffix}.` });
      rc.value = false;
    }
    if (!form['fall4YearCostOther' + planSuffix] || form['fall4YearCostOther' + planSuffix].length === 0) {
      requiredFields.push({ requirement: `Please indicate your Other Fees costs for Plan ${planSuffix}.` });
      rc.value = false;
    }
    if (!form['fall4YearCostMealPlan' + planSuffix] || form['fall4YearCostMealPlan' + planSuffix].length === 0) {
      requiredFields.push({ requirement: `Please indicate your Meal Plan costs for Plan ${planSuffix}.` });
      rc.value = false;
    }
  }
  // Career Training
  if (planType === 'career_training') {
    if (!form['fallCCTradeNameLocation' + planSuffix] || form['fallCCTradeNameLocation' + planSuffix].length === 0) {
      requiredFields.push({ requirement: `Please indicate the Plan ${planSuffix} College/School Name/Location.` });
      rc.value = false;
    }
    if (!form['fallTradeOrMajor' + planSuffix] || form['fallTradeOrMajor' + planSuffix].length === 0) {
      requiredFields.push({ requirement: `Please indicate your Plan ${planSuffix} Trade or Major.` });
      rc.value = false;
    }
    if (!form['fallCCTradeCareerGoal' + planSuffix] || form['fallCCTradeCareerGoal' + planSuffix].length === 0) {
      requiredFields.push({ requirement: `Please indicate your Plan ${planSuffix} Career Goals.` });
      rc.value = false;
    }
    if (!form['fallCCTradeStartDate' + planSuffix] || form['fallCCTradeStartDate' + planSuffix].length === 0) {
      requiredFields.push({ requirement: `Please indicate your Start Date for Plan ${planSuffix} Career Training` });
      rc.value = false;
    }
    if (!form['myFuturePlanCost' + planSuffix] || form['myFuturePlanCost' + planSuffix].length === 0) {
      requiredFields.push({ requirement: `Please indicate your Plan ${planSuffix} Cost.` });
      rc.value = false;
    }
  }
  // Military
  if (planType === 'military') {
    if (!form['fallMilitaryBranch' + planSuffix] || form['fallMilitaryBranch' + planSuffix].length === 0) {
      requiredFields.push({ requirement: `Please indicate the Plan ${planSuffix} Branch of Military.` });
      rc.value = false;
    }
    if (
      (!form['fallMilitaryMepsDate' + planSuffix] || form['fallMilitaryMepsDate' + planSuffix].length === 0) &&
      !form['fallMilitaryMepsDateDoNotKnow' + planSuffix]
    ) {
      requiredFields.push({ requirement: 'Please indicate the MEPS date or indicate you do not yet know it.' });
      rc.value = false;
    }
    if (
      form['fallMilitaryMepsDateDoNotKnow' + planSuffix] &&
      (!form['fallMilitaryMepsDateDoNotKnowReason' + planSuffix] || form['fallMilitaryMepsDateDoNotKnowReason' + planSuffix].length === 0)
    ) {
      requiredFields.push({ requirement: `Please indicate the reason you do not know your Plan ${planSuffix} MEPS date.` });
      rc.value = false;
    }
    if (
      (!form['fallMilitaryBasicTrainingDate' + planSuffix] || form['fallMilitaryBasicTrainingDate' + planSuffix].length === 0) &&
      !form['fallMilitaryBasicTrainingDateDoNotKnow' + planSuffix]
    ) {
      requiredFields.push({ requirement: 'Please indicate the basic training date or indicate you do not yet know it.' });
      rc.value = false;
    }
    if (
      form['fallMilitaryBasicTrainingDateDoNotKnow' + planSuffix] &&
      (!form['fallMilitaryBasicTrainingDateDoNotKnowReason' + planSuffix] ||
        form['fallMilitaryBasicTrainingDateDoNotKnowReason' + planSuffix].length === 0)
    ) {
      requiredFields.push({ requirement: `Please indicate the reason you do not know your Plan ${planSuffix} basic training date.` });
      rc.value = false;
    }
    if (!form['fallMilitaryRecruiter' + planSuffix] || form['fallMilitaryRecruiter' + planSuffix].length === 0) {
      requiredFields.push({ requirement: `Please indicate the name of the your Plan ${planSuffix} military recruiter.` });
      rc.value = false;
    }
  }
  // Workforce
  if (planType === 'workforce') {
    if (!form['fallEmploymentPlace' + planSuffix] || form['fallEmploymentPlace' + planSuffix].length === 0) {
      requiredFields.push({ requirement: `Please indicate your Plan ${planSuffix} Place of Employment.` });
      rc.value = false;
    }
    if (!form['workForceStartDate' + planSuffix] || form['workForceStartDate' + planSuffix].length === 0) {
      requiredFields.push({ requirement: `Please indicate Plan ${planSuffix} Start Date.` });
      rc.value = false;
    }
    if (!form['fallEmploymentFullPartTime' + planSuffix] || form['fallEmploymentFullPartTime' + planSuffix].length === 0) {
      requiredFields.push({ requirement: `Please indicate Plan ${planSuffix} Type of Employment.` });
      rc.value = false;
    }
  }

  if (['college', '2-year-college', 'career_training'].includes(planType)) {
    if (!form['fall4YearFamilyAssistance' + planSuffix] || form['fall4YearFamilyAssistance' + planSuffix].length === 0) {
      requiredFields.push({ requirement: `Please indicate your expected Family Assistance for Plan ${planSuffix}.` });
      rc.value = false;
    }
  }
  if (['college', '2-year-college', 'career_training', 'workforce'].includes(planType)) {
    if (!form['fall4YearLivingArrangements' + planSuffix] || form['fall4YearLivingArrangements' + planSuffix].length === 0) {
      requiredFields.push({ requirement: `Please indicate your Living Arrangements for Plan ${planSuffix}.` });
      rc.value = false;
    }
    if (!form['fall4YearTransportationRequirements' + planSuffix] || form['fall4YearTransportationRequirements' + planSuffix].length === 0) {
      requiredFields.push({ requirement: `Please indicate your Transportation Requirements for Plan ${planSuffix}.` });
      rc.value = false;
    }
  }
  if (!form['myFutureBarriers' + planSuffix] || form['myFutureBarriers' + planSuffix].length === 0) {
    requiredFields.push({
      requirement: `Please indicate your - What are the general barriers you have at this point to continue with Plan ${planSuffix}.`,
    });
    rc.value = false;
  }
  if (!form['myFutureSupports' + planSuffix] || form['myFutureSupports' + planSuffix].length === 0) {
    requiredFields.push({ requirement: `Please indicate - What supports do you need to continue with Plan ${planSuffix}.` });
    rc.value = false;
  }
  if (!form['myFutureTasks' + planSuffix] || form['myFutureTasks' + planSuffix].length === 0) {
    requiredFields.push({ requirement: `Please indicate - What tasks do I need to complete to move toward my Plan ${planSuffix}.` });
    rc.value = false;
  }
};

// Validate backup plan and tasks (for both version 1 and 2)
export const validateBackupPlanAndTasks = (form, requiredFields, rc) => {
  if (form.version && form.version === PLANNING_MEETING_FORM_VERSION) return;
  if (!form.backupPlan || form.backupPlan.length === 0) {
    requiredFields.push({ requirement: 'Please describe your fall backup plan.' });
    rc.value = false;
  }
  if (!form.backupPlanPreparations || form.backupPlanPreparations.length === 0) {
    requiredFields.push({ requirement: 'Please describe your fall backup plan preparations in order to be successful.' });
    rc.value = false;
  }
  if (!form.backupPlanLiving || form.backupPlanLiving.length === 0) {
    requiredFields.push({ requirement: 'Please describe where you will live as part of your backup plan.' });
    rc.value = false;
  }
  if (!form.backupPlanCost || form.backupPlanCost.length === 0) {
    requiredFields.push({ requirement: 'Please describe how you will pay for your backup plan.' });
    rc.value = false;
  }
  if (!form.backupPlanNeed || form.backupPlanNeed.length === 0) {
    requiredFields.push({ requirement: 'Please describe what items you would need for your backup plan.' });
    rc.value = false;
  }
  if (!form.backupPlanHelp || form.backupPlanHelp.length === 0) {
    requiredFields.push({ requirement: 'Please describe who would help you with your backup plan.' });
    rc.value = false;
  }
  let tasksCompleted = 0;
  if (Array.isArray(form.tasks)) {
    form.tasks.forEach((t) => {
      if (t.name && t.name.length > 0) {
        tasksCompleted += 1;
      }
    });
  }
  if (tasksCompleted < 3) {
    requiredFields.push({ requirement: 'Please list at least three tasks you need to complete to move toward your plan.' });
    rc.value = false;
  }
};
